import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import './Schedule.css'
import { WeddingSchedule } from '../Constants'

const Schedule = () => {
    const { friendlyURL } = useParams()
    const [events, setEvents] = useState([])
    const [colourScheme, setColourScheme] = useState('pink')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        setLoading(true)
        setError('')
        axios.post(`${process.env.REACT_APP_API}/weddings/get-schedule-by-url`, { friendlyURL })
            .then(res => {
                setEvents(Array.isArray(res.data?.events) ? res.data.events : [])
                if (res.data?.colourScheme) setColourScheme(res.data.colourScheme)
            })
            .catch(() => {
                setError('Unable to load schedule')
            })
            .finally(() => setLoading(false))
    }, [friendlyURL])

    if (loading) return <div>Loading…</div>
    if (error) return <div>{error}</div>

    // Helpers to sort times like in CustomSiteSchedule
    const timeToMinutes = (time) => {
        const [h, m] = (time || '00:00').split(':').map(Number)
        return h * 60 + m
    }

    const sorted = [...events].sort((a, b) => {
        const aMin = timeToMinutes(a.startTime)
        const bMin = timeToMinutes(b.startTime)
        const aAdj = aMin < 300 ? aMin + 1440 : aMin
        const bAdj = bMin < 300 ? bMin + 1440 : bMin
        return aAdj - bAdj
    })

    return (
        <div className={`public-schedule ${colourScheme}-schedule`}>
            <div className="public-schedule__content">
                <h3>Schedule of the day</h3>

                {sorted.length === 0 ? (
                    <p className="empty">No events scheduled yet</p>
                ) : (
                    sorted.map((item, i) => {
                        const lastIndex = sorted.length - 1
                        const eventInfo = WeddingSchedule.find(e => e.id == item.eventId)
                        return (
                            <div key={`${item.event}-${i}`} className="row">
                                <div className="timeline">
                                    <div className={i === 0 ? 'line none' : 'line'} />
                                    <div className="dot" />
                                    <div className={i === lastIndex ? 'line none' : 'line'} />
                                </div>
                                <div className="card">
                                    {eventInfo?.icon && (
                                        <img className="icon" src={eventInfo.icon} alt={eventInfo?.name} />
                                    )}
                                    <div className="details">
                                        <p className="time">{item.startTime}{item.endTime ? ` - ${item.endTime}` : ''}</p>
                                        <p className="title">{item.event}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    )
}

export default Schedule